<!--  设备运维-操作箱格  -->
<template>
<!-- 模板一，不改变面包屑 -->
  <div class="mainArea OperateBox">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
              操作箱格
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"

  export default {
    name: 'OperateBox',
    components: {
      BreadCrumb,
    }, 
    data() {
      return {
      }
    },
    mounted(){
    },
    created: async function () {

    },
    methods: {

    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    },
    props: []
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Page/Maintain/DeviceMaintain/OperateBox.vue